<script>
  import draft from 'stores/Draft';
  import tinycolor from 'tinycolor2';
  export let selectedYarn = -1;
  let color;
  $: if (Number(selectedYarn) !== -1) {
    let ratio = $draft.yarn.find((a) => a.id === Number(selectedYarn)).color;
    color = tinycolor.fromRatio(ratio).toHexString();
  }
</script>

<div class="color-dropdown">
  <select bind:value={selectedYarn} on:input>
    <option value={-1}>Add new yarn</option>
    {#each $draft.yarn as yarn}
      <option value={yarn.id}>
        {yarn.name}
      </option>
    {/each}
  </select>
  {#if selectedYarn !== -1}
    <div class="color-marker" style={`background-color: ${color}`} />
  {/if}
</div>

<style>
  select {
    margin: 0;
    padding: 0;
  }

  .color-dropdown {
    display: flex;
  }
  .color-marker {
    width: 1em;
    border: 1px solid black;
  }
</style>
